import { render, staticRenderFns } from "./QueryRootsTree.vue?vue&type=template&id=41499c7f&scoped=true&"
import script from "./QueryRootsTree.vue?vue&type=script&lang=js&"
export * from "./QueryRootsTree.vue?vue&type=script&lang=js&"
import style0 from "./QueryRootsTree.vue?vue&type=style&index=0&id=41499c7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41499c7f",
  null
  
)

export default component.exports